import { render, staticRenderFns } from "./InvestigationForm.vue?vue&type=template&id=c35844ec&scoped=true&"
import script from "./InvestigationForm.vue?vue&type=script&lang=js&"
export * from "./InvestigationForm.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationForm.vue?vue&type=style&index=0&id=c35844ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35844ec",
  null
  
)

export default component.exports